/* eslint-disable */
import React, {createContext, useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import {HubConnectionBuilder, IHttpConnectionOptions, HubConnectionState} from '@microsoft/signalr';
import {verificationRequestConstants} from '../redux/ninVerification/reducer';
import {env, remoteRoutes} from '../constants'
import {IState} from '../types'
import {getToken} from '../../utils/ajax';
import {IPersonProfile} from '../../app/modules/kyc/person/interfaces/IPersonProfile';
import {ICompanyProfile} from '../../app/modules/kyc/company/interfaces/ICompanyProfile';
import {KYC_VERIFICATION_CONSTANTS} from '../redux/verification/reducer';
import { STORE_CRM_PERSON_CONSTANTS } from '../redux/crmPersons/workflowsReducer';
import { STORE_CRM_COMPANY_CONSTANTS } from '../redux/crmCompanies/workflowsReducer';
import { REDUX_CRM_PERSONS_CONSTANTS } from '../redux/crmPersons/reducer';
import { REDUX_CRM_COMPANIES_CONSTANTS } from '../redux/crmCompanies/reducer';
import { DOWNLOADS_CONSTANTS } from '../redux/downloads/reducer';
import { REDUX_AUDIT_TRAIL } from '../redux/auditTrailReducer';
import { REDUX_PAY } from '../redux/pay/reducer';


const WebSocketContext = createContext(null)

export {WebSocketContext}

interface IProps {
    children: any
}

export default ({children}: IProps) => {
    const userProfile = useSelector((state: IState) => state.core);
    const [connection, setConnection]: any = useState();
    const [kycConnection, setKycConnection]: any = useState();
    const [crmConnection, setCrmConnection]: any = useState();
    const [csvConnection, setCsvConnection]: any = useState();
    const [atConnection, setAtConnection]: any = useState();
    const [payConnection, setPayConnection]: any = useState();
    let webSocket: any;
    const dispatch = useDispatch();

    const joinKycGroup = async (groupName: any) => {
        try {
            await kycConnection.invoke('AddToGroup', groupName);
        } catch (error) {
            console.error(error);
        }
    };

    const joinCrmGroup = async (groupName: any) => {
        try {
            await crmConnection.invoke('AddToGroup', groupName);
        } catch (error) {
            console.error(error);
        }
    };

    const joinCsvGroup = async (groupName: any) => {
        try {
            await csvConnection.invoke('AddToGroup', groupName);
        } catch (error) {
            console.error(error);
        }
    };

    const joinAtGroup = async (groupName: any) => {
        try {
            await atConnection.invoke('AddToGroup', groupName);
        } catch (error) {
            console.error(error);
        }
    };

    const joinPayGroup = async (groupName: any) => {
        try {
            await payConnection.invoke('AddToGroup', groupName);
        } catch (error) {
            console.error(error);
        }
    };

    const removeFromGroup = async (groupName: any) => {
        try {
            await connection.invoke('RemoveFromGroup', groupName);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        const CRMConnection = new HubConnectionBuilder()        
            .withUrl(remoteRoutes.webSocketsCRM, {
                accessTokenFactory: () => (
                    getToken()
                )
            } as IHttpConnectionOptions)
            .withAutomaticReconnect()
            .build();
            setCrmConnection(CRMConnection);

        const KYCConnection = new HubConnectionBuilder()
            .withUrl(remoteRoutes.webSocketsKYC, {
                accessTokenFactory: () => (
                    getToken()
                )
            } as IHttpConnectionOptions)
            .withAutomaticReconnect()
            .build();
            setKycConnection(KYCConnection);

        const CSVConnection = new HubConnectionBuilder()        
            .withUrl(remoteRoutes.webSocketsCSV, {
                accessTokenFactory: () => (
                    getToken()
                )
            } as IHttpConnectionOptions)
            .withAutomaticReconnect()
            .build();
            setCsvConnection(CSVConnection);

        const ATConnection = new HubConnectionBuilder()        
            .withUrl(remoteRoutes.webSocketsAT, {
                accessTokenFactory: () => (
                    getToken()
                )
            } as IHttpConnectionOptions)
            .withAutomaticReconnect()
            .build();
            setAtConnection(ATConnection);

        const PAYConnection = new HubConnectionBuilder()        
            .withUrl(remoteRoutes.webSocketsPAY, {
                accessTokenFactory: () => (
                    getToken()
                )
            } as IHttpConnectionOptions)
            .withAutomaticReconnect()
            .build();
            setPayConnection(PAYConnection);
    }, []);

    const startKycConnection = async () => {
        try {
            await kycConnection.start();

            if (kycConnection && kycConnection.state === HubConnectionState.Connected) {
                joinKycGroup(userProfile.user.tenantid)
                kycConnection.on('ReceiveLastRunChecks', (message: any) => {
                    dispatch({
                        type: KYC_VERIFICATION_CONSTANTS.REQUEST_DETAILS,
                        payload: message
                    });
                });
            }

        } catch (err) {
            if (kycConnection && kycConnection.state === HubConnectionState.Disconnected) {
                console.log(err);
                setTimeout(() => startKycConnection(), 5000);
            }
        }
    }

    const startCrmConnection = async () => {
        try {
            await crmConnection.start();
            if (crmConnection && crmConnection.state === HubConnectionState.Connected) {
                joinCrmGroup(userProfile.user.tenantid)
                crmConnection.on('ReceiveCustomerProfile', (message: any) => {
                    
                    if (message?.personProfile) {
                        const P: IPersonProfile  = message?.personProfile
                        dispatch({
                            type: STORE_CRM_PERSON_CONSTANTS.crmPersonReceiveProfile,
                            payload: P,
                        });
                
                        dispatch({
                            type: REDUX_CRM_PERSONS_CONSTANTS.CrmPersonRequestsReceiveProfile,
                            payload: P,
                        });
                    }

                    if (message?.companyProfile) {
                        const C: ICompanyProfile = message?.companyProfile
                        dispatch({
                            type: STORE_CRM_COMPANY_CONSTANTS.workflowsReceiveProfile,
                            payload: C,
                        });

                        dispatch({
                            type: REDUX_CRM_COMPANIES_CONSTANTS.RequestsReceiveProfile,
                            payload: C,
                        });
                    }
                });
            }

        } catch (err) {
            if (crmConnection && crmConnection.state === HubConnectionState.Disconnected) {
                console.log(err);
                setTimeout(() => startCrmConnection(), 5000);
            }

        }
    }

    const startCsvConnection = async () => {
        try {
            await csvConnection.start();
            if (csvConnection && csvConnection.state === HubConnectionState.Connected) {
                joinCsvGroup(userProfile.user.tenantid)
                csvConnection.on('ReceiveExport', (message: any) => {

                    dispatch({
                        type: DOWNLOADS_CONSTANTS.READY,
                        payload: message.response
                    });
                });
            }

        } catch (err) {
            if (csvConnection && csvConnection.state === HubConnectionState.Disconnected) {
                console.log(err);
                setTimeout(() => startCsvConnection(), 5000);
            }
        }
    }

    const startATConnection = async () => {
        try {
            await atConnection.start();
            if (atConnection && atConnection.state === HubConnectionState.Connected) {
                joinAtGroup(userProfile.user.tenantid)
                atConnection.on('ReceiveAuditTrails', (message: any) => {
                    dispatch({
                        type: REDUX_AUDIT_TRAIL.FetchAll,
                        payload: message?.audits
                    });
                });
            }

        } catch (err) {
            if (atConnection && atConnection.state === HubConnectionState.Disconnected) {
                console.log(err);
                setTimeout(() => startATConnection(), 5000);
            }
        }
    }

    const startPayConnection = async () => {
        try {
            await payConnection.start();
            if (payConnection && payConnection.state === HubConnectionState.Connected) {
                joinPayGroup(userProfile.user.tenantid)
                payConnection.on('PublishTransactionStatus', (message: any) => {
                    dispatch({
                        type: REDUX_PAY.TRANSACTION,
                        payload: message
                    });
                });
                
            }

        } catch (err) {
            if (payConnection && payConnection.state === HubConnectionState.Disconnected) {
                console.log(err);
                setTimeout(() => startPayConnection(), 5000);
            }
        }
    }

    if (userProfile.user === null) {
        kycConnection && kycConnection.connection.stopConnection()
        crmConnection && crmConnection.connection.stopConnection()
        csvConnection && csvConnection.connection.stopConnection()
        atConnection && atConnection.connection.stopConnection()
        payConnection && payConnection.connection.stopConnection()
    }
    webSocket = {
        connection
    }
    userProfile.user && startKycConnection();
    kycConnection && kycConnection.onclose(userProfile.user && startKycConnection);

    userProfile.user && startCrmConnection();
    crmConnection && crmConnection.onclose(userProfile.user && startCrmConnection);

    userProfile.user && startCsvConnection();
    csvConnection && csvConnection.onclose(userProfile.user && startCsvConnection);

    userProfile.user && startATConnection();
    atConnection && atConnection.onclose(userProfile.user && startATConnection);

    userProfile.user && startPayConnection();
    payConnection && payConnection.onclose(userProfile.user && startPayConnection);

    return (
        <WebSocketContext.Provider value={webSocket}>
            {children}
        </WebSocketContext.Provider>
    )
}